import type { VersionId } from '../../common/model';
import type { Props as AppProps, FieldId, Operation, FieldCollection } from '../model/types';

// INITIALIZE APP PROPS
export const INITIALIZE_APP_PROPS = 'delete-version.state.INITIALIZE_APP_PROPS' as const;

export type InitializeAppPropsAction = {
	type: typeof INITIALIZE_APP_PROPS;
	payload: AppProps;
};

export const initializeAppProps = (appProps: AppProps): InitializeAppPropsAction => ({
	type: INITIALIZE_APP_PROPS,
	payload: appProps,
});

// GET RELATED ISSUES COUNT
export const GET_RELATED_ISSUES_COUNT = 'delete-version.state.GET_RELATED_ISSUES_COUNT' as const;

export type GetRelatedIssuesCountAction = {
	type: typeof GET_RELATED_ISSUES_COUNT;
};

export const getRelatedIssuesCount = (): GetRelatedIssuesCountAction => ({
	type: GET_RELATED_ISSUES_COUNT,
});

// SET RELATED ISSUES COUNT
export const SET_RELATED_ISSUES_COUNT = 'delete-version.state.SET_RELATED_ISSUES_COUNT' as const;

export type SetRelatedIssuesCountPayload = FieldCollection;

export type SetRelatedIssuesCountAction = {
	type: typeof SET_RELATED_ISSUES_COUNT;
	payload: SetRelatedIssuesCountPayload;
};

export const setRelatedIssuesCount = (
	payload: SetRelatedIssuesCountPayload,
): SetRelatedIssuesCountAction => ({
	type: SET_RELATED_ISSUES_COUNT,
	payload,
});

// SHOW DIALOG
export const SHOW_DIALOG = 'delete-version.state.SHOW_DIALOG' as const;

export type ShowDialogAction = {
	type: typeof SHOW_DIALOG;
};

export const showDialog = (): ShowDialogAction => ({
	type: SHOW_DIALOG,
});

// DELETE VERSION
export const DELETE_VERSION = 'delete-version.state.DELETE_VERSION' as const;

export type DeleteVersionAction = {
	type: typeof DELETE_VERSION;
};

export const deleteVersion = (): DeleteVersionAction => ({
	type: DELETE_VERSION,
});

// SET OPERATION FOR FIELD
export const SET_OPERATION_FOR_FIELD = 'delete-version.state.SET_OPERATION_FOR_FIELD' as const;

export type SetOperationForFieldPayload = {
	fieldId: FieldId;
	operation: Operation;
};

export type SetOperationForFieldAction = {
	type: typeof SET_OPERATION_FOR_FIELD;
	payload: SetOperationForFieldPayload;
};

export const setOperationForField = (
	payload: SetOperationForFieldPayload,
): SetOperationForFieldAction => ({
	type: SET_OPERATION_FOR_FIELD,
	payload,
});

// SET VERSION FOR FIELD
export const SET_VERSION_FOR_FIELD = 'delete-version.state.SET_VERSION_FOR_FIELD' as const;

export type SetVersionForFieldPayload = {
	fieldId: FieldId;
	target: VersionId;
};

export type SetVersionForFieldAction = {
	type: typeof SET_VERSION_FOR_FIELD;
	payload: SetVersionForFieldPayload;
};

export const setVersionForField = (
	payload: SetVersionForFieldPayload,
): SetVersionForFieldAction => ({
	type: SET_VERSION_FOR_FIELD,
	payload,
});

// DELETION SUCCESS
export const DELETION_SUCCESS = 'delete-version.state.DELETION_SUCCESS' as const;

export type DeletionSuccessAction = {
	type: typeof DELETION_SUCCESS;
};

export const deletionSuccess = (): DeletionSuccessAction => ({
	type: DELETION_SUCCESS,
});

// DELETION FAILURE
export const DELETION_FAILURE = 'delete-version.state.DELETION_FAILURE' as const;

export type DeletionFailurePayload = Error;

export type DeletionFailureAction = {
	type: typeof DELETION_FAILURE;
	payload: DeletionFailurePayload;
};

export const deletionFailure = (payload: DeletionFailurePayload): DeletionFailureAction => ({
	type: DELETION_FAILURE,
	payload,
});

export const CANCEL = 'delete-version.state.CANCEL' as const;

export type CancelAction = {
	type: typeof CANCEL;
};

export const cancel = (): CancelAction => ({
	type: CANCEL,
});

export type Action =
	| InitializeAppPropsAction
	| GetRelatedIssuesCountAction
	| SetRelatedIssuesCountAction
	| DeleteVersionAction
	| ShowDialogAction
	| SetOperationForFieldAction
	| SetVersionForFieldAction
	| DeletionSuccessAction
	| DeletionFailureAction
	| CancelAction;
